import React from "react";

import { ViewActivity } from "app/userManagement/modules/generic/index";

const AdminViewActivity = () => {
  return (
    <>
      <ViewActivity />
    </>
  );
};

export default AdminViewActivity;
